// Top-navbar entries a non-admin user can see, and the keys the business-wide
// "Postavke → Navigacija" switches store in Business.cfg_nav_hidden.
//
// Keys must match backend-mt app/utils/nav_visibility.py NAV_KEYS (the backend
// rejects anything else). Admin-only entries (Stats, Trends, IVR, Postavke) are
// not listed: they never show to non-admins, so they need no switch.
export type NavKey =
  | 'deliveries'
  | 'calls'
  | 'reservations'
  | 'handoff'
  | 'menu'
  | 'tables'
  | 'local_orders'
  | 'deliverymen';

export interface NavItemDef {
  key: NavKey;
  path: string;
  label: string;
  icon: string;
}

export const NAV_ITEMS: readonly NavItemDef[] = [
  { key: 'deliveries',   path: '/deliveries',   label: 'Narudžbe',     icon: '📋' },
  { key: 'calls',        path: '/calls',        label: 'Pozivi',       icon: '📞' },
  { key: 'reservations', path: '/reservations', label: 'Rez',          icon: '📅' },
  { key: 'handoff',      path: '/handoff',      label: 'Primopredaja', icon: '🤝' },
  { key: 'menu',         path: '/menu',         label: 'Meni',         icon: '🍽️' },
  { key: 'tables',       path: '/tables',       label: 'Stolovi',      icon: '🪑' },
  { key: 'local_orders', path: '/local-orders', label: 'Lokal',        icon: '🧾' },
  { key: 'deliverymen',  path: '/deliverymen',  label: 'Dostava',      icon: '🛵' },
];

export const NAV_ITEM: Record<NavKey, NavItemDef> = Object.fromEntries(
  NAV_ITEMS.map((i) => [i.key, i]),
) as Record<NavKey, NavItemDef>;

const NAV_KEY_SET = new Set<string>(NAV_ITEMS.map((i) => i.key));

/** Keep only known keys, so an unexpected API value can't break the navbar. */
export function parseNavHidden(value: unknown): NavKey[] {
  if (!Array.isArray(value)) return [];
  return value.filter((v): v is NavKey => typeof v === 'string' && NAV_KEY_SET.has(v));
}
